import { computed, observable, runInAction } from 'mobx';
import { get } from '../utils';

class MyOrderNum {
    private route: string;
    @observable
    public number: any = [];
    public couponsNumber: any;

    constructor(params: any) {
        this.route = params.url;
    }

    async fetch(callback?, errs?) {
        get(this.route, {}).then((d) => {
            let data;
            if (d.data) {
                data = d.data;
                runInAction(() => {
                    this.number = data;
                    callback && callback(data);
                });
            } else {
                callback && callback([]);
            }
        }).catch((err) => {
            errs && errs(err);
        });
    }

    fetch2(callback?, errs?) {
        return get('user/coupon/v1/weixin/mycount').then((d) => {
            let data = d.data;
            if (d.errCode === 200) {
                runInAction(() => {
                    this.couponsNumber = data;
                    callback && (this.couponsNumber = callback(data));
                });
            } else {
                callback && callback([]);
            }
        }).catch((err) => {
            errs && errs(err);
        });
    }

    @computed
    get numberData() {
        return this.number.slice();
    }
}

export default MyOrderNum;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/model/MyOrderNum.ts